import { render, staticRenderFns } from "./RunCourseHeader.vue?vue&type=template&id=a866da80&scoped=true"
import script from "./RunCourseHeader.vue?vue&type=script&lang=ts"
export * from "./RunCourseHeader.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=a866da80&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a866da80",
  null
  
)

export default component.exports